var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.siteDisplay}},[_c('vue-headful',{attrs:{"head":{'link[rel=icon]': {href: _vm.faviconURL}}}}),_c('router-view',{key:_vm.$route.fullPath,attrs:{"name":_vm.template}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }